import React from "react";

import { getStorageUser } from "../../helpers/api_helper";
import { PROFILES } from "../../components/VerticalLayout/SidebarContent";
import Dashboard from ".";
import EmptyDashboard from "./EmptyDashboard";
import OperadorDashboard from "./Operador/OperadorDashboard";

const DashboardSwitcher = () => {
  document.title = "Inicio | Sistema de Logística";

  const user = getStorageUser();

  // El operador ve solo sus salidas del dia; el dashboard general son KPIs de toda la empresa
  if (user.profile_id === PROFILES.Operador) {
    return <OperadorDashboard />;
  }

  if (![PROFILES.Reseller, PROFILES.SuperAdmin].includes(user.profile_id)) {
    return <Dashboard />;
  }

  return <EmptyDashboard />;
};
export default DashboardSwitcher;
